export const getShortUid = (uid: string) => {
  const shortUid = uid.slice(-6);
  return shortUid.toUpperCase();
};
